@switch (getWrapperType()) {
  @case ('floatlabel') {
    <p-floatlabel [variant]="to.floatLabel || 'in'">
      <p-inputnumber
        #inputNumber
        [formControl]="formControl"
        [formlyAttributes]="field"
        [inputId]="id"
        [placeholder]="to.placeholder || ''"
        [readonly]="!!to.readonly"
        [size]="to.size!"
        [variant]="to.variant!"
        [mode]="to.mode || 'decimal'"
        [min]="to.min"
        [max]="to.max"
        [step]="to.step"
        [minFractionDigits]="to.minFractionDigits"
        [maxFractionDigits]="to.maxFractionDigits"
        [useGrouping]="to.useGrouping"
        [currency]="to.currency"
        [currencyDisplay]="to.currencyDisplay"
        [locale]="to.locale"
        [prefix]="to.prefix"
        [suffix]="to.suffix"
        [showButtons]="to.showButtons || false"
        [buttonLayout]="to.buttonLayout || 'stacked'"
        [inputStyle]="to.inputStyle"
        [inputStyleClass]="to.inputStyleClass"
        [styleClass]="to.styleClass"
        [ariaLabel]="to.ariaLabel"
        [ariaLabelledBy]="to.ariaLabelledBy"
        [class.ng-invalid]="showError"
        [class.ng-dirty]="formControl.dirty"
        [class.ng-touched]="formControl.touched"
        (onInput)="onInput($event)"
        (onFocus)="onFocus($event)"
        (onBlur)="onBlur($event)"
        (onKeyDown)="onKeyDown($event)">
        @if (to.incrementButtonIcon) {
          <ng-template #incrementbuttonicon>
            <span [class]="to.incrementButtonIcon"></span>
          </ng-template>
        }
        @if (to.decrementButtonIcon) {
          <ng-template #decrementbuttonicon>
            <span [class]="to.decrementButtonIcon"></span>
          </ng-template>
        }
      </p-inputnumber>
      <label [for]="id">{{ to.label }}</label>
    </p-floatlabel>
  }
  @case ('iftalabel') {
    <p-iftalabel>
      <p-inputnumber
        #inputNumber
        [formControl]="formControl"
        [formlyAttributes]="field"
        [inputId]="id"
        [placeholder]="to.placeholder || ''"
        [readonly]="!!to.readonly"
        [size]="to.size!"
        [variant]="to.variant!"
        [mode]="to.mode || 'decimal'"
        [min]="to.min"
        [max]="to.max"
        [step]="to.step"
        [minFractionDigits]="to.minFractionDigits"
        [maxFractionDigits]="to.maxFractionDigits"
        [useGrouping]="to.useGrouping"
        [currency]="to.currency"
        [currencyDisplay]="to.currencyDisplay"
        [locale]="to.locale"
        [prefix]="to.prefix"
        [suffix]="to.suffix"
        [showButtons]="to.showButtons || false"
        [buttonLayout]="to.buttonLayout || 'stacked'"
        [inputStyle]="to.inputStyle"
        [inputStyleClass]="to.inputStyleClass"
        [styleClass]="to.styleClass"
        [ariaLabel]="to.ariaLabel"
        [ariaLabelledBy]="to.ariaLabelledBy"
        [class.ng-invalid]="showError"
        [class.ng-dirty]="formControl.dirty"
        [class.ng-touched]="formControl.touched"
        (onInput)="onInput($event)"
        (onFocus)="onFocus($event)"
        (onBlur)="onBlur($event)"
        (onKeyDown)="onKeyDown($event)">
        @if (to.incrementButtonIcon) {
          <ng-template #incrementbuttonicon>
            <span [class]="to.incrementButtonIcon"></span>
          </ng-template>
        }
        @if (to.decrementButtonIcon) {
          <ng-template #decrementbuttonicon>
            <span [class]="to.decrementButtonIcon"></span>
          </ng-template>
        }
      </p-inputnumber>
      <label [for]="id">{{ to.label }}</label>
    </p-iftalabel>
  }
  @default {
    @if (to.label) {
      <label [for]="id" class="block mb-2">
        {{ to.label }}
        @if (to.required) {
          <span class="text-red-500 ml-1">*</span>
        }
      </label>
    }
    <p-inputnumber
      #inputNumber
      [formControl]="formControl"
      [formlyAttributes]="field"
      [inputId]="id"
      [placeholder]="to.placeholder || ''"
      [readonly]="!!to.readonly"
      [size]="to.size!"
      [variant]="to.variant!"
      [mode]="to.mode || 'decimal'"
      [min]="to.min"
      [max]="to.max"
      [step]="to.step"
      [minFractionDigits]="to.minFractionDigits"
      [maxFractionDigits]="to.maxFractionDigits"
      [useGrouping]="to.useGrouping"
      [currency]="to.currency"
      [currencyDisplay]="to.currencyDisplay"
      [locale]="to.locale"
      [prefix]="to.prefix"
      [suffix]="to.suffix"
      [showButtons]="to.showButtons || false"
      [buttonLayout]="to.buttonLayout || 'stacked'"
      [inputStyle]="to.inputStyle"
      [inputStyleClass]="to.inputStyleClass"
      [styleClass]="to.styleClass"
      [ariaLabel]="to.ariaLabel"
      [ariaLabelledBy]="to.ariaLabelledBy"
      [class.ng-invalid]="showError"
      [class.ng-dirty]="formControl.dirty"
      [class.ng-touched]="formControl.touched"
      (onInput)="onInput($event)"
      (onFocus)="onFocus($event)"
      (onBlur)="onBlur($event)"
      (onKeyDown)="onKeyDown($event)">
      @if (to.incrementButtonIcon) {
        <ng-template #incrementbuttonicon>
          <span [class]="to.incrementButtonIcon"></span>
        </ng-template>
      }
      @if (to.decrementButtonIcon) {
        <ng-template #decrementbuttonicon>
          <span [class]="to.decrementButtonIcon"></span>
        </ng-template>
      }
    </p-inputnumber>
    @if (to.description && !showError) {
      <small [id]="id + '_description'" class="text-gray-600 block mt-1">
        {{ to.description }}
      </small>
    }
  }
}
